import React from 'react'

const ImamHussein = () => {
  return (
   <>
       <div className='container karbala'>
            <div className="page-head mt-5">

                <div className="text-box">
                    <h2>İmam Hüseyn</h2>
                    <img src="https://i0.wp.com/sapelosquare.com/wp-content/uploads/2017/10/tumblr_nwzmo79gwp1qkkfszo1_1280.jpg?resize=1200%2C580&ssl=1" alt="" />
                </div>
            </div>

            <div className="main-part">
                <h3>İmam Hüseyn Haqqında</h3>
<p>
Imam Huseyn (a) haqqinda

Əsrlər keçməsinə baxmayaraq, hər il olduğu kimi "İmam Hüseyn (ə) kimdir?" sualının cavabını bilib, dərk edənlər yəni İmam Hüseyn (ə) aşiqləri dünyanın hər yerində artan istiqamətdə əzədarlıq məclisləri keçirir. İmamın (ə) bəşərə verdiyi ali dəyərlərdən danışılır və qəm yaşanır - o qəm ki, kökündə optimistlik dayanır. Bu qəm ilə, saxlanılan əza ilə İmamın (ə) uğrunda hər şeyindən keçdiyi, şəhid olduğu dəyərlər dünyaya çatdırılır...
"Hüseyn (ə) kimdir?" sualı tarix boyu, elə İmamın (ə) yaşadığı dövrdən öz aktuallığını günümüzədək daşımışdır.
Imam Huseyn (ə) haqqında qısa məlumat
<br />
5-ci İMAM HÜSEYN (ƏLEYHİSSALAM)
<br />
Ləqəbləri: Seyyidüş-şühəda, Rəşid, Təyyib, Vəfiyy, Zəkiyy, Seyyid, Səid, Mübarək, Sibtüs-sani, Əttabiu-limərzatillah, Əşşəhidu bi-Kərbəla, Əddəlilu əla zatillah, Əl-imamus-salis.
<br/>
Künyəsi: Əbu Əbdillah.
<br/>
Atası: Əmirəl-möminin Əliyyibni Əbitalib (əleyhissalam).
<br/>
Anası: Fatimeyi Zəhra (salamullahi əleyha).
<br/>
Doğulduğu gün: 3 Şəban.
<br/>
Doğulduğu yer: Mədineyi-Münəvvərə.
<br/>
Doğulduğu il: Hicrətdən 3 il sonra.
<br/>
Şəhid olduğu gün: Məhərrəmin onu, cümə günü.
<br/>
Şəhid olduğu il: 61-ci hicri ili.
<br/>
Ömrü: 58 il.
<br/>
Şəhadət səbəbi: Yezid ibn Müaviyənin hökmü ilə öz əhli-beyti ilə birlikdə şəhadətə çatmışdır.
<br/>
Dəfn olunduğu yer: Müqəddəs Kərbəla şəhəri.
<br/>
Övladlarının sayı: 6 (4 oğlan, 2 qız).
<br/>
Oğlanları:
<br/>
1. Əli Əkbər.
<br/>
2. Əliyyi Övsət (İmam Zeynül-Abidin əleyhissalam).
<br/>
3. Cəfər.
<br/>
4. Əbdüllah.
<br/>
Qızları:
<br/>
1. Səkinə.
<br/>
2. Fatimə.

İmamın nəsli oğlu Zeynəl-Abidindən (əleyhissalam) davam etmişdir. Əli Əkbər atası ilə birlikdə Kərbəlada şəhid olmuş və o Həzrətin yanında dəfn edilmişdir. Cəfər (anası Qusaiyyədir) atasının sağlığında vəfat etmiş, Mədineyi-Münəvvərədə dəfn olunmuşdur. Əbdüllah isə uşaqlıq çağında (6 aylıq) atasının qucağında şəhid edilmişdir. Ona Əli Əsğər də deyilir.

Belə ki, İmam Hüseynin (ə) yaşadığı dövrə baxsaq, bir tərəfdə İmamın (ə) vilayətini dərk edib, ona ruhən və cismən bağlı olanların, digər cərgədə isə "Hüseyn (ə) kimdir?" sualının cavabını bilən, amma İmama (ə) qarşı çıxan xəbis, qəlbi daşlaşmış insanabənzər məxluqları görürük.
Düşmən İmam Hüseyni (ə) çox yaxşı tanıyırdı.
Aşura günü İmam (ə) meydana çıxdıqda düşmənə xitabən: "Siz məni tanımırsınız? Bilmirsiziniz ki, mən Rəsuli-Əkrəmin (s), Əmirəl-Mömininin (ə), Fatimeyi-Zəhranın (s.ə) oğluyam?".
Bu adları çəkərkən babası Rəsulallahın (ə), atası Əmirəl-möminin Əlinin (ə), anası Həzrət Zəhranın (s.ə) ayrıca fəzilətlərindən də danışdı və çatırdı ki, Hüseynəm (ə) və siz bilin kimə qarşı çıxmısınız.
Düşmən çox yaxşı bilirdi, çox yaxşı tanıyırdı kimdir Hüseyn (ə). Öz xəbis, çirklənmiş nəfsinin əsirinə, quluna çevrilmiş ruhları imkan vermirdi İmamın (ə) yanında olmağa. Odur ki, İmam (ə) sağ qaldıqca bu dünyalarında rahat yaşaya bilməyəcəklərini, zülmlərini rahat davam etdirə bilməyəcəklərini, dini folklora çevirə bilməyəcəklərini anlayırdılar.
"Hüseyn kimdir?" sualı ilə mübarizə aparırdılar. Düşmən tərəf insanların başını "bir xarici var" deyərək, aldadıb döyüşə gətirmişdi.
Tarix yazır ki, İmam (ə) Mədinədən çox az saylı adamla çıxmışdı, xeyli insan İmama (ə) Kərbəlada düşmən qoşunundan qoşuldular. Çünkü İmam Hüseyn (ə) həqiqətini dərk etdilər.
Günümüzə gəldikdə isə dəyişən bir şeyin olmadığını görürük.
"Hüseyn (ə) kimdir?" sualının qarşısında bir tərəfdə onu sevənləri, bir tərəfdə isə ona qarşı çıxmaqla bütün insani dəyərləri tapdayan düşmənləri görürük.
Düşmən bu gün çox yaxşı bilir ki, Kərbəlanın yaşanması hər kəsin oyanışı deməkdir. Kərbəlanın yaşanması dünyada zülmə "dur!" deməkdir.
Kərbəlada Ərbəin günü milyonların toplaşıb İmam Hüseynə (ə) əza saxladığını görən düşmən tərəfin generalı bu sözləri deyir: "Mən bu mənzərəni görəndə həyəcanlandım və qorxdum ki, bu ruhiyyə ilə üzərimizə gəlsələr, bizdən bir nəfər də qalmaz bu topraqda".
Hər bir iş ağ və qara səhifədən ibarət olur. Bizlər bu gün hər hansı bir tarixi hadisəni danışarkən onun yalnız qara səhifəsin danışsaq, təbiidir ki, bu, insanlarda mənfi təsir qoyacaq.
Kərbəla hadisəsində biz ancaq ağ səhifəsindən deyil, yalnız qara səhifəsindən danışsaq, bu, günümüzdə olduğu kimi, Kərbəlanı anlamamağa gətirib çıxaracaq və düşmən də bundan istifadə edib, daim bu dəyəri gözdən salmağa çalışacaq.
Böyük mütəfəkkir Mürtəza Mütəhhəri Kərbəla mövzsunda çıxışlarının böyük bir hissəsini bu mövzuya ayırır. Bu mövzunun həlli üçün köklü baxışlar ortaya qoyur.
"Niyə biz həmişə Kərbəla hadisəsini tarixin qara səhifəsi baxımından mütaliə etməliyik? Niyə həmişə Kərbəlanın cinayətləri deyilməlidir? Niyə həmişə Hüseyn ibn Əlini (ə) cinayətkarların əzabına məruz qalmaq baxımından mütaliə etməliyik? Niyə Hüseyn ibn Əlinin (ə) adına səsləndirdiyimiz və yazdığımız şüarlar, Aşuranın qaranlıq səhifəsindən götürülməlidir? Bu dastanın qəhrəmanlıq tərəfi onun cinayət tərəfindən 100 dəfələrlə faydalı olduğu halda, niyə biz o işıqlı səhifəni az mütaliə edirik? Bu hadisənin işığı onun qaranlığından çox faydalıdır. Deməli, gərək etiraf edək ki, Hüseyn ibn Əlinin (ə) cinayətkarlarından biri də bizik ki, bu tarixçədən yalnız bir səhifə oxuyuruq və başqa səhifəni oxumuruq. İmam Hüseynin (ə) cinayətkarları həm də bu tarixçəni hədəf baxımından keçmişdə və bu gün dəyişdirənlərdir".
Allahım, bizləri bu məktəbi dərk edib, yaşayanlardan olmağı nəsib et.
</p>

                <h3>İmam Hüseynin (ə) Yezidə beyət etməkdən imtina etməsi</h3>

                <p>
                    Müaviyənin ölümündən sonra (15 rəcəb, 60 h.q.), ölümündən əvvəlki səyləri nəticəsində,[2] oğlu Yezid üçün camaatdan beyət alındı;[3] Əlbətdə imam Həsənin (ə) Müaviəylə bağladığı sülhnaməyə əsasən, Müaviyənin haqqı yox idi özündən sonra canişin təyin etsin.[4] Yezid bu qərara gəldi ki, müsəlmanlar arasında bir neçə tanınmış böyük şəxslərdən ki, Müaviyə onun üçün beyət ala bilməmişdi, beyət alsın.[5] Odur ki, o zaman Mədinənin hakimi olan Vəlid ibn Ütbəyə namə yazaraq ondan istədi, Hüseyn ibn Əli (ə), Abdullah ibn Ömər, Əbdurrəman ibn Əbi-Bəkr və Abdullah ibn Zübeyrdən zor gücünə olsa da belə, beyət alsın və hər hansı biri boyun qaçırarsa, boyunlarını vursun.[6] Sonralar isə, Yeziddən başqa bir məktub Vəlidin əlinə çatdı ki, onda təkid olunmuşdu: “Mənimlə müvafiq və müxalif olanların adlarını qeyd edib Hüseynin (ə) başını isə məktubun cavabıyla birlikdə mənə göndər”.[7] Vəlid bu haqda Mərvanla məsləhətləşərək [8] Abdullah ibn Öməri, imam Hüseyn (ə), ibn Zübeyr, Abdullah ibn Ömər və Əbdürrəhman ibn Bikr-in arxasınca göndərdi.[9]
                    <br />
                    İmam Hüseyn (ə) öz yaxınlarından ibarət 30 nəfərlə birlikd,[10] Mədinənin Darul-imarə adlanan saraya getdi.[11] Vəlid, Müaviyənin ölüm xəbərini həzrətə verdikdən sonra, Yezidin məktubunu onun üçün oxudu ki, o məktubda Vəliddən istənilmişdi, Hüseyn ibn Əlidən (ə) beyət alınsın. İmam Hüseyn (ə) Vəlidə dedi: “Güman edirəm məqsədin budur ki, mənim beyətim camaat qarşısında olsun.”Vəlid cavab verdi: “Mənim fikrim budur.”[12] İmam (ə) buyurdu: “Belədirsə, sabaha kimi mənə fürsət ver, öz fikrimi bildirim.”[13] Mədinənin hakimi, sabahı gün, əsr vaxtı, öz məmurlarını, imam Hüseynin (ə) evinə göndərdi ki, cavab alsın.[14] İmam Hüseyn (ə) Vəlidin razılığı əsasında o gecəni də möhlət aldı.[15] Bu möhlətdən sonra, imam (ə) bu qərara gəldi ki, Mədinəni tərk etsin.[16]
                </p>
            </div>
        </div>
   </>
  )
}

export default ImamHussein